import { Pipe, PipeTransform } from '@angular/core';
// Deep import on purpose: the helpers barrel pulls in `@angular/common/http` at runtime, which
// this lib's plain ts-jest setup cannot load.
import { formatPhone } from '@digilize/shared/utils/helpers/src/lib/formatPhone';

/**
 * Renders a stored phone number the way a reader in `homeCountry` expects it (PAUL-3440). Pass the
 * shop's country where it is known; it defaults to NL.
 */
@Pipe({
  name: 'phone',
  standalone: false,
})
export class PhonePipe implements PipeTransform {
  transform(value: string | null | undefined, homeCountry?: string | null): string {
    return formatPhone(value, homeCountry);
  }
}
